import BaseApi from "./BaseApi";

export const getCountries = async () => {
  return await BaseApi.get(`/reservationProcess/GetCountriesList`);
};



// WEBPACK FOOTER //
// ./src/api/countries.js